export default __webpack_public_path__ + "static/kb1_kb2_main-fb0e16df70ad99faf0b299f24286fc15.png";